import React from 'react'

const ScheduledTab = (props) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill={props ? props.color : '#FFFFFF'}
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.99992 0.333496C3.32392 0.333496 0.333252 3.32416 0.333252 7.00016C0.333252 10.6762 3.32392 13.6668 6.99992 13.6668C10.6759 13.6668 13.6666 10.6762 13.6666 7.00016C13.6666 3.32416 10.6759 0.333496 6.99992 0.333496ZM6.99992 12.3335C4.05925 12.3335 1.66659 9.94083 1.66659 7.00016C1.66659 4.0595 4.05925 1.66683 6.99992 1.66683C9.94059 1.66683 12.3333 4.0595 12.3333 7.00016C12.3333 9.94083 9.94059 12.3335 6.99992 12.3335Z"
        />
        <path d="M7.66659 3.66683H6.33325V7.66683H10.3333V6.3335H7.66659V3.66683Z"/>
    </svg>
)

export default ScheduledTab
